import React, { useEffect } from 'react';
import * as R from 'ramda';

import { StyledTabs, StyledTab } from './StyledTabs';
import { Typography, Paper } from '@mui/material';
import { noop } from '@cd/utils';

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { withRouter } from 'react-router-dom';

import { css } from '@emotion/react';
import { stagger, useAnimate } from 'framer-motion';

const tabRoot = css({
	marginTop: '4px',
	'@media print': {
		display: 'none'
	},
	transition: 'all 0.3s'
});
const moveToLeft = css({
	marginLeft: '0px',
	'.MuiSvgIcon-root': {
		transform: 'translate(26px, 0px)'
	}
});
const padding = theme =>
	css({
		padding: theme.spacing(1)
	});
const panelColor = css({
	backgroundColor: 'transparent'
});

const panelColorVert = css({
	borderRadius: '4px',
	borderTop: '14px solid transparent',
	borderRight: '14px solid transparent',
	borderLeft: '4px solid transparent'
});
const panelColorVertInverted = css({
	borderRadius: '4px',
	borderTop: '14px solid transparent',
	borderRight: '14px solid transparent',
	borderLeft: '4px solid transparent'
});

const smallButtonBorder = css({
	borderRight: '4px solid transparent'
});

const enhance = withRouter;

const matchRoute = (mask, route, currentRoute = '') =>
	R.compose(
		R.pathOr('', [1]),
		R.match(mask),
		R.defaultTo(R.is(Array, route) ? route[0] : route),
		R.when(R.is(Array), R.find(R.equals(currentRoute)))
	)(route);

const TabsCD = ({
	tabs = [],
	isColorReversed,
	dark,
	initialValue = 0,
	onTabChange = noop,
	orientation,
	disabled,
	variant,
	color,
	urlMaskRegEx
}) => {
	const theme = useTheme();
	const vertical = orientation === 'vertical';
	const [scope, animate] = useAnimate();
	useEffect(() => {
		if (vertical) return;
		animate(
			'button',
			{
				//opacity: [0, 1],
				borderBottom: '1px solid',
				borderBottomColor: [
					'rgba(255,255,255,1)',
					'rgba(255,255,255,0)'
				]
				//backgroundColor: ['rgba(255,255,255,1)', 'rgba(255,255,255,0)']
			},
			{ duration: 1, delay: stagger(0.2) }
		);
	}, []);

	const value = urlMaskRegEx
		? matchRoute(urlMaskRegEx, initialValue)
		: initialValue;

	function handleChange(e, newValue) {
		const { route } =
			tabs.find(({ route }) => route.match(new RegExp(newValue))) || {};

		onTabChange(route);
	}

	const isSmall = useMediaQuery('(max-width:800px)');
	const isVerySmall = useMediaQuery('(max-width:500px)') && vertical;

	return !R.isEmpty(tabs) ? (
		<div css={[tabRoot, isVerySmall && moveToLeft]}>
			<Paper
				elevation={vertical ? 1 : 0}
				css={[
					!vertical && !isColorReversed && panelColor,
					vertical && !isColorReversed && panelColorVert,
					isVerySmall && smallButtonBorder,
					vertical && isColorReversed && panelColorVertInverted
				]}>
				<StyledTabs
					ref={scope}
					dark={dark}
					isSmall={isSmall}
					vertical={vertical}
					value={value}
					onChange={handleChange}
					aria-label="TabsCD"
					orientation={orientation}>
					{tabs.map(({ name, route }, index) => (
						<StyledTab
							variant={variant}
							color={color}
							isSmall={isSmall}
							dark={dark}
							vertical={vertical}
							label={name}
							key={name}
							value={
								urlMaskRegEx
									? matchRoute(
											urlMaskRegEx,
											route,
											value,
											index
									  )
									: route
							}
						/>
					))}
				</StyledTabs>
				<Typography css={padding(theme)} />
			</Paper>
		</div>
	) : null;
};
export default enhance(TabsCD);
